/* =Toggle menu icon when drawer is open
-------------------------------------------------------------- */

$(document).ready(function(){
  (function($) {
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    $.fn.attrchange = function(callback) {
      if (MutationObserver) {
          var options = {
              subtree: false,
              attributes: true
          };

          var observer = new MutationObserver(function(mutations) {
              mutations.forEach(function(e) {
                  callback.call(e.target, e.attributeName);
              });
          });

          return this.each(function() {
              observer.observe(this, options);
          });
      }
    }
  })(jQuery);

  //Now you need to append event listener
  $('#PageContainer').attrchange(function(attrName) {
    var $node = $( this );
    if( $node.hasClass( "is-transitioning" ) ) {
      //console.log('open');
      $('#menu-icon').toggleClass('open');
      } else {
      //console.log('closed');
      $('#menu-icon').toggleClass('open');
    }

    if(attrName=='class'){
      //console.log('class changed');
    } else {
      //OTHER ATTR CHANGED
    }
  });
});

/* Thumbnail slider
--------------------*/
$(function() {
  $('.slider-thumbs-gallery').slick({
    arrows: true,
    autoplay: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4
  });

$('.slider-thumbs').slick({
    arrows: true,
    autoplay: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});


/* =FancyBox
-------------------------------------------------------------- */

$(function() {
  $('.fancybox').fancybox({
    padding: 0,
    margin: 40,
    helpers : {

      title : {
          type : 'outside'
      },

      overlay : {
        css : {
            'background' : 'rgba(255, 255, 255, 0.8)'
        }
      }
    }
  });
});

/* Sharing Popups
--------------------*/

$(".share-it").click(function(){
window.open($(this).attr("href"), 'social_share', 'height=288, width=750, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, directories=no, status=no');
return false;
}); 

/* animate.css and wow.js animations
---------------------------------*/

jQuery(document).ready(function($){
  var animations = function() {
    if($(window).width() > 620) { // Show this only on larger screens 
      $('.header-logo img').addClass('fadeIn');
      $('.index-section:first-child').addClass('fadeIn');
      $('.index-section:nth-child(2)').addClass('fadeIn');
      $('.index-section').addClass('fadeInUp');
      $('.index-section:first-child').removeClass('fadeInUp');
      $('.index-section:nth-child(2)').removeClass('fadeInUp');

      $('.template-page-about .top-section').addClass('fadeIn');
      $('.template-page-about .top-section .img-wrapper').addClass('fadeInUp');
      $('.template-page-about .custom-item').addClass('fadeInUp');
    } 
  };

  // Fire on DOM ready
  animations();

  // Fire upon resize
  $(window).resize(animations);
});

/* Hide zoom effect when Lifter pop-up is open
--------------------*/


  (function($) {
    $(document).ready(function() {
      var $fancyboxPopup = $('.fancyboxPop-opened');
      var popupLoaded = false;
      var popupClosed = false;
      
      var popupTimer = setInterval(function() {      
        var $fancyboxPopup = $('.fancyboxPop-opened');
        //console.log($fancyboxPopup, popupLoaded, popupClosed);
        
        if ($fancyboxPopup.length === 0) {
          $('#PageContainer').addClass('zoom-enabled');
        }
        else {
          $('#PageContainer').removeClass('zoom-enabled');
          popupLoaded = true;
        }

        // Check if Popup was Closed
        if (popupLoaded && $fancyboxPopup.length === 0) {
          popupClosed = true;
        }
        
        // Clear popupTimer
        if (popupClosed) {
          clearInterval(popupTimer);
        }
      }, 500);
    });
  })(jQuery);
